
import inspPermis from "./permission/inspPermis";
import btnPermis  from "./permission/btnPermis"
import rulePermis  from "./permission/rulePermis"
export default {
    install(Vue) {
        Vue.directive('inspPermis', inspPermis)
        Vue.directive('btnPermis',btnPermis)
        Vue.directive('rulePermis', rulePermis)

    }
}
